import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';

interface Auth0ProviderProps {
  children: React.ReactNode;
}

const Auth0ProviderWrapper: React.FC<Auth0ProviderProps> = ({ children }: Auth0ProviderProps) => {
  // Hardcoded Auth0 configuration - no environment variables needed
  const domain = 'dev-auywx6eq8pzjd3b3.us.auth0.com';
  const clientId = '7AO7hAEXg9TFJNwlCDQeuWERptBsvg5V';
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
  const redirectUri = window.location.origin;

  console.log('🔍 Auth0 Configuration Debug:', {
    domain,
    clientId: clientId ? `${clientId.substring(0, 8)}...` : 'Not set',
    audience: audience || 'not requested',
    redirectUri,
    'process.env.REACT_APP_AUTH0_DOMAIN': process.env.REACT_APP_AUTH0_DOMAIN,
    'process.env.REACT_APP_AUTH0_CLIENT_ID': process.env.REACT_APP_AUTH0_CLIENT_ID,
    'process.env.REACT_APP_AUTH0_AUDIENCE': process.env.REACT_APP_AUTH0_AUDIENCE
  });


  const authorizationParams: Record<string, string> = {
    redirect_uri: redirectUri,
    scope: 'openid profile email'
  };

  if (audience) {
    authorizationParams.audience = audience;
  }

  console.log('🚀 Auth0Provider rendering with:', {
    domain,
    clientId: clientId ? `${clientId.substring(0, 8)}...` : 'Not set',
    authorizationParams,
    'Will render Auth0Provider': true
  });

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={authorizationParams}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      // Preserve user data - don't clear on logout
      skipRedirectCallback={false}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWrapper;
